/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateConditionRequest
 */
export interface CreateConditionRequest {
    /**
     * サービス種別
     * @type {number}
     * @memberof CreateConditionRequest
     */
    serviceCategory: CreateConditionRequestServiceCategoryEnum;
    /**
     * 金銭区分
     * @type {number}
     * @memberof CreateConditionRequest
     */
    moneyCategory: CreateConditionRequestMoneyCategoryEnum;
    /**
     * 費目名
     * @type {string}
     * @memberof CreateConditionRequest
     */
    expenseItemName: string;
    /**
     * 手数料率
     * @type {number}
     * @memberof CreateConditionRequest
     */
    feePercentage: number;
    /**
     * 税区分
     * @type {number}
     * @memberof CreateConditionRequest
     */
    taxKind: CreateConditionRequestTaxKindEnum;
    /**
     * 集計期間区分 1=1日〜月末 2=A: 1日〜15日,B: 16日〜月末
     * @type {number}
     * @memberof CreateConditionRequest
     */
    aggregationPeriodKind: CreateConditionRequestAggregationPeriodKindEnum;
    /**
     * 精算処理日区分 1=翌月1日 2=A: 当月16日,B: 翌月1日
     * @type {number}
     * @memberof CreateConditionRequest
     */
    processingPeriodKind: CreateConditionRequestProcessingPeriodKindEnum;
    /**
     * 備考
     * @type {string}
     * @memberof CreateConditionRequest
     */
    description?: string;
}


/**
 * @export
 */
export const CreateConditionRequestServiceCategoryEnum = {
    OVERSEAS_ROAMING: 0
} as const;
export type CreateConditionRequestServiceCategoryEnum = typeof CreateConditionRequestServiceCategoryEnum[keyof typeof CreateConditionRequestServiceCategoryEnum];

/**
 * @export
 */
export const CreateConditionRequestMoneyCategoryEnum = {
    OVERSEAS_APP_PLATFORM_SALES: 0,
    TIP: 1,
    CANCELLATION_FEE: 2,
    TAXIFARE: 3
} as const;
export type CreateConditionRequestMoneyCategoryEnum = typeof CreateConditionRequestMoneyCategoryEnum[keyof typeof CreateConditionRequestMoneyCategoryEnum];

/**
 * @export
 */
export const CreateConditionRequestTaxKindEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type CreateConditionRequestTaxKindEnum = typeof CreateConditionRequestTaxKindEnum[keyof typeof CreateConditionRequestTaxKindEnum];

/**
 * @export
 */
export const CreateConditionRequestAggregationPeriodKindEnum = {
    ONCE_MONTH: 1,
    TWICE_MONTH: 2
} as const;
export type CreateConditionRequestAggregationPeriodKindEnum = typeof CreateConditionRequestAggregationPeriodKindEnum[keyof typeof CreateConditionRequestAggregationPeriodKindEnum];

/**
 * @export
 */
export const CreateConditionRequestProcessingPeriodKindEnum = {
    ONCE_MONTH: 1,
    TWICE_MONTH: 2
} as const;
export type CreateConditionRequestProcessingPeriodKindEnum = typeof CreateConditionRequestProcessingPeriodKindEnum[keyof typeof CreateConditionRequestProcessingPeriodKindEnum];


/**
 * Check if a given object implements the CreateConditionRequest interface.
 */
export function instanceOfCreateConditionRequest(value: object): value is CreateConditionRequest {
    if (!('serviceCategory' in value) || value['serviceCategory'] === undefined) return false;
    if (!('moneyCategory' in value) || value['moneyCategory'] === undefined) return false;
    if (!('expenseItemName' in value) || value['expenseItemName'] === undefined) return false;
    if (!('feePercentage' in value) || value['feePercentage'] === undefined) return false;
    if (!('taxKind' in value) || value['taxKind'] === undefined) return false;
    if (!('aggregationPeriodKind' in value) || value['aggregationPeriodKind'] === undefined) return false;
    if (!('processingPeriodKind' in value) || value['processingPeriodKind'] === undefined) return false;
    return true;
}

export function CreateConditionRequestFromJSON(json: any): CreateConditionRequest {
    return CreateConditionRequestFromJSONTyped(json, false);
}

export function CreateConditionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateConditionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'serviceCategory': json['service_category'],
        'moneyCategory': json['money_category'],
        'expenseItemName': json['expense_item_name'],
        'feePercentage': json['fee_percentage'],
        'taxKind': json['tax_kind'],
        'aggregationPeriodKind': json['aggregation_period_kind'],
        'processingPeriodKind': json['processing_period_kind'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function CreateConditionRequestToJSON(json: any): CreateConditionRequest {
    return CreateConditionRequestToJSONTyped(json, false);
}

export function CreateConditionRequestToJSONTyped(value?: CreateConditionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'service_category': value['serviceCategory'],
        'money_category': value['moneyCategory'],
        'expense_item_name': value['expenseItemName'],
        'fee_percentage': value['feePercentage'],
        'tax_kind': value['taxKind'],
        'aggregation_period_kind': value['aggregationPeriodKind'],
        'processing_period_kind': value['processingPeriodKind'],
        'description': value['description'],
    };
}

